import React, { useState } from 'react';

import './InfoAccordion.scss'

import MinusIcon from "../../../img/minus2.png"
import PlusIcon from "../../../img/plus2.png"



const InfoAccordion = ( {
    title,
    content
    }) =>{

    const [open, setOpen] = useState();
    
        
    return (
        <div className="infoAccordion">
            <div className = "infoAccordionTitle"
                onClick = {()=>{
                    open ?  
                    setOpen(false)
                    :
                    setOpen(true)
                    }}>
                <span>{title}</span> 
                {
                    open ?
                    <img 
                    src={MinusIcon}
                    width="24" 
                    height="24" />
                    :
                    <img 
                    src={PlusIcon}
                    width="24" 
                    height="24" 
                    />
                }         
            </div>
            { open &&
                <div className = "infoAccordionContent">
                {content}
            </div>

            }
            
        </div>
    )
}


export default InfoAccordion;